export const getSearchString = (filters) => {
    if (!filters) {
        return ''
    }

    const searchString = Object.keys(filters).reduce((search, key) => {
        let currentValue = filters[key]

        if (Array.isArray(currentValue)) {
            currentValue = currentValue
                .map((item) => {
                    if (typeof item === 'object') {
                        return item.value
                    }
                    return item
                })
                .join()
        }

        if (typeof currentValue === 'boolean') {
            currentValue = currentValue ? '1' : '0'
        }

        if (!currentValue) {
            return search
        } else {
            currentValue = currentValue.toString().trim()
        }

        return (search += `${key}:${currentValue};`)
    }, '')

    return searchString.slice(0, -1)
}

export const getQueryString = (query) => {
    return Object.keys(query)
        .map((key) => `${key}=${query[key]}`)
        .join('&')
}

export const addApiPrefixAndSuffixOnServerUrl = (serverUrl, isAddApiSuffix = true) => {
    if (process.env.NODE_ENV === 'development') {
        return isAddApiSuffix ? addApiSuffix(serverUrl) : serverUrl
    }

    let serverUrlArray = stringToArray(serverUrl, '.')
    let serverUrlPrefixAdded = ''
    serverUrlArray = addApiPrefix(serverUrlArray)
    serverUrlPrefixAdded = arrayToString(serverUrlArray, '.')
    return isAddApiSuffix ? addApiSuffix(serverUrlPrefixAdded || serverUrl) : serverUrlPrefixAdded || serverUrl
}

const arrayToString = (array, separator) => array.join(separator)
const stringToArray = (string, separator) => string.split(separator)
const addApiPrefix = (array) => {
    array.splice(1, 0, 'api')
    return array
}
const addApiSuffix = (string) => string + '/api'
